
export default {
    inheritAttrs: false,

    props: {
        editItem: {
            type: Object,
            required: true,
        },
        collName: {
            type: String,
            required: true,
        },
        fieldPath: {
            type: String,
            required: true,
        },
        readonly: Boolean,
        getXf: Function,
        setXf: Function,
        noLabel: Boolean,
        pathPrefix: String,
        fallbackFn: [String, Function],
        labelVariant: String,
        errors: Object,
    },

    computed: {
        fullPath() {
            return this.withPrefix(this.fieldPath);
        },
        label() {
            return (
                this.noLabel ? undefined :
                this.error ? this.errorMessage :
                $.getFieldLabel(this.collName, this.fullPath, [this.labelVariant, 'detail', 'long'])
            );
        },
        model: {
            get() {
                const val = $.get(this.editItem, this.fieldPath);

                // Transform value before returning
                return !this.getXf ? val : this.getXf(val, this.editItem);
            },
            set(value) {
                if (this.errors) {
                    this.errors[this.fieldPath] = null;
                }

                // Transform value before setting
                const val = !this.setXf ? value : this.setXf(value, this.editItem);

                $.set(this.editItem, this.fieldPath, val);
            },
        },
        fallback() {
            return (
                !this.fallbackFn ? undefined :
                typeof this.fallbackFn === 'function' ? this.fallbackFn(this.editItem) :
                $.get(this.editItem, this.fallbackFn)
            );
        },
        errorMessage() {
            return this.errors && this.errors[this.fieldPath];
        },
        error() {
            return !!this.errorMessage;
        },
        bindables() {
            return {
                label: this.label,
                readonly: this.readonly,
                placeholder: this.fallback,
                error: this.error,
                ...this.$attrs,
            };
        },
    },

    methods: {
        withPrefix(path) {
            return !this.pathPrefix ? path : `${this.pathPrefix}.${path}`;
        },
    },
};
